import React, { PureComponent, PropTypes } from 'react';
import Row from './row';
import { STATUS_HIDDEN, STATUS_DELETED } from '../../services/Card';
import { addVectors,  createVectorConstraintCheck, getMovementVector, isMovement } from '../../services/InputManager';
import { localise } from '../../services/Language';

const rxCellName = /cell_(\d+)_(\d+)/;
const getIdAndColumn = (name) => {
    return rxCellName
        .exec(name)
        .map(val => parseInt(val, 10)) // convert to number
        .filter((n, i) => i !== 0);    // strip match[0], which is the string itself
};

class Grid extends PureComponent {
    constructor(...args) {
        super(...args);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }
    changeFocus(row, col) {
        let { data } = this.props;
        let [ id ] = data[row];
        let inputName = `cell_${id}_${col}`;

        let inputElement = document.querySelector(`input[name=${inputName}]`);
        inputElement.focus();

        if (requestAnimationFrame) requestAnimationFrame(() => inputElement.select());
        else setTimeout(() => inputElement.select(), 100);
    }
    handleKeyDown(evt) {
        if (! isMovement(evt) ) return evt;
        let vector = getMovementVector(evt);
        let { target } = evt;
        let { name, selectionStart, selectionEnd, value } = target;

        let { data } = this.props;

        let [rowId, column] = getIdAndColumn(name);

        let row = data.reduce((carry, row, index) => Math.max(carry, (row[0] === rowId ? index : carry)), -1);

        let checkBoundsOverflow = createVectorConstraintCheck([0, 0], [3, this.props.data.length - 1]);

        let [nextRow, nextColumn] = [row, column];

        while(true) {
            let nextPoint = addVectors(vector, [nextColumn, nextRow]);
            if (checkBoundsOverflow(nextPoint) === false) break;
            nextColumn = nextPoint[0];
            nextRow = nextPoint[1];

            let [,state] = data[nextRow];

            if (state === STATUS_DELETED || state === STATUS_HIDDEN) continue;
            break;
        }

        let isSelection = selectionStart === 0 && selectionEnd === value.length;

        if ((nextColumn < column && selectionStart === 0 && isSelection) ||
            (nextColumn > column && selectionEnd === value.length && isSelection) ||
            (nextRow < row) ||
            (nextRow > row)) this.changeFocus(nextRow, nextColumn);

        return evt;
    }
    render() {
        let { data, onCellChange, onImport, onStateChange } = this.props;
        let { handleKeyDown } = this;
        let rowCount = data.length;
        let rows = data.map((row, index) => {
            let [ id, state,, ...values ] = row;

            let props = { handleKeyDown, id, onCellChange, onStateChange, state, values };
            return <Row
                key={id}
                lastRow={ index >= rowCount - 1 }
                { ...props }
            />;
        });

        return (<div className="grid">
            <div className="panel-tab" onClick={ onImport }><h5>{ localise('Import cards') }</h5></div>
            <h1>{ localise('Cards') }</h1>
            { rows }
        </div>);
    }
}

Grid.propTypes = {
    data: PropTypes.array.isRequired,
    onCellChange: PropTypes.func.isRequired,
    onImport: PropTypes.func.isRequired
};

export default Grid;


// WEBPACK FOOTER //
// ./src/components/deckeditor/grid.js